import React, {useState, useEffect} from "react";
import styled from 'styled-components';
import tw from "twin.macro";
import {ReactComponent as Cabinet} from './QuestionsIcon/Cabinet.svg';
import {ReactComponent as Ichoda} from './QuestionsIcon/Ichod.svg';
import {ReactComponent as Ichodashia} from './QuestionsIcon/Ichodashia.svg';
import {ReactComponent as NezvPos} from './QuestionsIcon/NezvPos.svg';
import {ReactComponent as Yslugi} from './QuestionsIcon/Yslugi.svg';
import {ReactComponent as Tariff} from './QuestionsIcon/QTariff.svg';
import {ReactComponent as Dostavka} from './QuestionsIcon/QDostavka.svg';
import {ReactComponent as Vozvrat} from './QuestionsIcon/QVozvrat.svg';
import {ReactComponent as Vukyp} from './QuestionsIcon/QVukyp.svg';
import {ReactComponent as Stahovka} from './QuestionsIcon/Qstrahovka.svg';
import {ReactComponent as Oplata} from './QuestionsIcon/QOplata.svg';
import {ReactComponent as Tamozha} from './QuestionsIcon/QTamozha.svg';
import {ReactComponent as Zaprehka} from './QuestionsIcon/QZaprehenka.svg';
import FAQs from '../../components/faqs/SingleCol';
import {useTranslation} from "react-i18next";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Footer from "../../components/footers/MainFooterWithLinks";
import Header from "../../components/headers/MainHeader";
import Photo from "../../images/img/quest.png";

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 15px;
    box-shadow: 2px 2px 10px rgba(45, 45, 45, 0.08);
    overflow: hidden;
    margin: 20px;
    height: auto;
    max-width: 1200px; /* Adjust the max-width as needed */
    margin: 20px auto; /* Center the layout */

    @media (min-width: 768px) {
        flex-direction: row;
        height: 100%;
    }

    @media (min-width: 1024px) {
        max-width: 1200px;
        margin: 20px auto; /* Центрирование */
    }
`;

const SidebarContainer = styled.div`
    display: flex;
    flex-direction: row;
    overflow-x: auto; /* Добавляем горизонтальный скроллинг */
    background: #ffffff;
    border-bottom: 1px solid #F5F5F5;

    @media (min-width: 768px) {
        flex-direction: column;
        overflow-x: visible; /* Убираем горизонтальный скроллинг на планшетах и десктопах */
        width: 200px;
        border-right: 1px solid #F5F5F5;
        border-bottom: none;
    }

    @media (min-width: 1024px) {
        width: 300px;
    }
`;

const TabButton = styled.button`
    ${tw`text-lg sm:text-xl font-semibold text-center`}
    display: flex;
    align-items: center;
    background: ${({active}) => (active ? '#DDF2E6' : 'transparent')};
    color: #243e63;
    border: none;
    /* Уменьшенные отступы */
    cursor: pointer;
    flex: 1;
    white-space: nowrap;

    &:hover {
        background-color: #DDF2E6;
    }

    svg {
        margin-right: 8px;
        width: 18px;
        height: 18px;

        @media (min-width: 768px) {
            margin-right: 12px;
            width: 22px;
            height: 22px;
        }

        @media (min-width: 1024px) {
            margin-right: 15px;
            width: 26px;
            height: 26px;
        }
    }

    @media (min-width: 768px) {
        font-size: 15px;
        padding: 14px; /* Уменьшенные отступы для планшетов */
    }

    @media (min-width: 1024px) {
        font-size: 16px;
    }
`;


const ContentContainer = styled.div`
    flex-grow: 1; /* Контейнер растягивается, чтобы занять оставшееся пространство */
    padding: 20px;
    transition: opacity 0.5s ease;
    opacity: ${({isActive}) => (isActive ? 1 : 0)};
    overflow: hidden; /* Убираем прокрутку */

    @media (min-width: 768px) {
        padding: 30px;
    }

    @media (min-width: 1024px) {
        max-width: 800px;
        margin: 0 auto; /* Центрируем */
    }
`;

const IconContainer = styled.span``;
const Title = styled.h1`
    ${tw`font-bold text-2xl mb-6 text-center md:text-left`}
    color: #243e63;
`;


export default function App() {
    const [activeTab, setActiveTab] = useState(0);

    const [isActive, setIsActive] = useState(true);
    const {t, i18n} = useTranslation();

    const tabs = [
        {
            name: t("faq.cabinet.name"),
            Icon: Cabinet,
            content: (
                <div>
                    <Title>{t("faq.cabinet.name")}</Title>
                    <FAQs
                        faqs={[
                            {
                                question: t("faq.cabinet.q1.question"),
                                answer: t("faq.cabinet.q1.answer")
                            },
                            {
                                question: t("faq.cabinet.q2.question"),
                                answer: t("faq.cabinet.q2.answer")
                            },
                            {
                                question: t("faq.cabinet.q3.question"),
                                answer: t("faq.cabinet.q3.answer")
                            },
                            {
                                question: t("faq.cabinet.q4.question"),
                                answer: t("faq.cabinet.q4.answer")
                            },
                            {
                                question: t("faq.cabinet.q5.question"),
                                answer: t("faq.cabinet.q5.answer")
                            },
                            {
                                question: t("faq.cabinet.q6.question"),
                                answer: t("faq.cabinet.q6.answer")
                            }
                        ]}
                    />
                </div>
            )
        },
        {
            name: t("faq.incoming.name"),
            Icon: Ichodashia,
            content: (
                <div>
                    <Title>{t("faq.incoming.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.incoming.q1.question"), answer: t("faq.incoming.q1.answer")},
                            {question: t("faq.incoming.q2.question"), answer: t("faq.incoming.q2.answer")},
                            {question: t("faq.incoming.q3.question"), answer: t("faq.incoming.q3.answer")},
                            {question: t("faq.incoming.q4.question"), answer: t("faq.incoming.q4.answer")},
                            {question: t("faq.incoming.q5.question"), answer: t("faq.incoming.q5.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.outgoing.name"),
            Icon: Ichoda,
            content: (
                <div>
                    <Title>{t("faq.outgoing.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.outgoing.q1.question"), answer: t("faq.outgoing.q1.answer")},
                            {question: t("faq.outgoing.q2.question"), answer: t("faq.outgoing.q2.answer")},
                            {question: t("faq.outgoing.q3.question"), answer: t("faq.outgoing.q3.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.unknown.name"),
            Icon: NezvPos,
            content: (
                <div>
                    <Title>{t("faq.unknown.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.unknown.q1.question"), answer: t("faq.unknown.q1.answer")},
                            {question: t("faq.unknown.q2.question"), answer: t("faq.unknown.q2.answer")},
                            {question: t("faq.unknown.q3.question"), answer: t("faq.unknown.q3.answer")},
                            {question: t("faq.unknown.q4.question"), answer: t("faq.unknown.q4.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.warehouse.name"),
            Icon: Yslugi,
            content: (
                <div>
                    <Title>{t("faq.warehouse.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.warehouse.q1.question"), answer: t("faq.warehouse.q1.answer")},
                            {question: t("faq.warehouse.q2.question"), answer: t("faq.warehouse.q2.answer")},
                            {question: t("faq.warehouse.q3.question"), answer: t("faq.warehouse.q3.answer")},
                            {question: t("faq.warehouse.q4.question"), answer: t("faq.warehouse.q4.answer")},
                            {question: t("faq.warehouse.q5.question"), answer: t("faq.warehouse.q5.answer")},
                            {question: t("faq.warehouse.q6.question"), answer: t("faq.warehouse.q6.answer")},
                            {question: t("faq.warehouse.q7.question"), answer: t("faq.warehouse.q7.answer")},
                            {question: t("faq.warehouse.q8.question"), answer: t("faq.warehouse.q8.answer")},
                            {question: t("faq.warehouse.q9.question"), answer: t("faq.warehouse.q9.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.tariffs.name"),
            Icon: Tariff,
            content: (
                <div>
                    <Title>{t("faq.tariffs.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.tariffs.q1.question"), answer: t("faq.tariffs.q1.answer")},
                            {question: t("faq.tariffs.q2.question"), answer: t("faq.tariffs.q2.answer")},
                            {question: t("faq.tariffs.q3.question"), answer: t("faq.tariffs.q3.answer")},
                            {question: t("faq.tariffs.q4.question"), answer: t("faq.tariffs.q4.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.delivery.name"),
            Icon: Dostavka,
            content: (
                <div>
                    <Title>{t("faq.delivery.name")}</Title>
                    <FAQs
                        faqs={[
                            {question: t("faq.delivery.q1.question"), answer: t("faq.delivery.q1.answer")},
                            {question: t("faq.delivery.q2.question"), answer: t("faq.delivery.q2.answer")},
                            {question: t("faq.delivery.q3.question"), answer: t("faq.delivery.q3.answer")},
                            {question: t("faq.delivery.q4.question"), answer: t("faq.delivery.q4.answer")},
                            {question: t("faq.delivery.q5.question"), answer: t("faq.delivery.q5.answer")},
                            {question: t("faq.delivery.q6.question"), answer: t("faq.delivery.q6.answer")},
                            {question: t("faq.delivery.q7.question"), answer: t("faq.delivery.q7.answer")},
                            {question: t("faq.delivery.q8.question"), answer: t("faq.delivery.q8.answer")}
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.return.name"),
            Icon: Vozvrat,
            content: (
                <div>
                    <Title>{t("faq.return.name")}</Title>
                    <FAQs
                        faqs={[
                            { question: t("faq.return.q1.question"), answer: t("faq.return.q1.answer") },
                            { question: t("faq.return.q2.question"), answer: t("faq.return.q2.answer") },
                            { question: t("faq.return.q3.question"), answer: t("faq.return.q3.answer") }
                        ]}
                    />
                </div>
            )
        }

        ,
        {
            name: t("faq.buyout.title"),
            Icon: Vukyp,
            content: (
                <div>
                    <Title>{t("faq.buyout.title")}</Title>
                    <FAQs
                        faqs={[
                            { question: t("faq.buyout.q1.question"), answer: t("faq.buyout.q1.answer") },
                            { question: t("faq.buyout.q2.question"), answer: t("faq.buyout.q2.answer") },
                            { question: t("faq.buyout.q3.question"), answer: t("faq.buyout.q3.answer") }
                        ]}
                    />
                </div>
            )
        },

        {
            name: t("faq.insurance.title"),
            Icon: Stahovka,
            content: (
                <div>
                    <Title>{t("faq.insurance.title")}</Title>
                    <FAQs
                        faqs={[
                            { question: t("faq.insurance.q1.question"), answer: t("faq.insurance.q1.answer") },
                            { question: t("faq.insurance.q2.question"), answer: t("faq.insurance.q2.answer") },
                            { question: t("faq.insurance.q3.question"), answer: t("faq.insurance.q3.answer") },
                            { question: t("faq.insurance.q4.question"), answer: t("faq.insurance.q4.answer") },
                            { question: t("faq.insurance.q5.question"), answer: t("faq.insurance.q5.answer") },
                            { question: t("faq.insurance.q6.question"), answer: t("faq.insurance.q6.answer") },
                            { question: t("faq.insurance.q7.question"), answer: t("faq.insurance.q7.answer") }
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.payment.title"),
            Icon: Oplata,
            content: (
                <div>
                    <Title>{t("faq.payment.title")}</Title>
                    <FAQs
                        faqs={[
                            {
                                question: t("faq.payment.q1.question"),
                                answer: t("faq.payment.q1.answer")
                            },
                            {
                                question: t("faq.payment.q2.question"),
                                answer: t("faq.payment.q2.answer")
                            }
                        ]}
                    />
                </div>
            )
        }
        ,
        {
            name: t("faq.customs.title"),
            Icon: Tamozha,
            content: (
                <div>
                    <Title>{t("faq.customs.title")}</Title>
                    <FAQs faqs={[
                        { question: t("faq.customs.q1.question"), answer: t("faq.customs.q1.answer") },
                        { question: t("faq.customs.q2.question"), answer: t("faq.customs.q2.answer") },
                        { question: t("faq.customs.q3.question"), answer: t("faq.customs.q3.answer") },
                        { question: t("faq.customs.q4.question"), answer: t("faq.customs.q4.answer") },
                    ]}/>
                </div>
            )
        }
        ,
        {
            name: t("faq.prohibited.title"),
            Icon: Zaprehka,
            content: (
                <div>
                    <Title>{t("faq.prohibited.title")}</Title>
                    <FAQs faqs={[
                        { question: t("faq.prohibited.q1.question"), answer: t("faq.prohibited.q1.answer") }
                    ]}/>
                </div>
            )
        }


    ];
    const [activeContent, setActiveContent] = useState(tabs[0].content);
    useEffect(() => {
        setIsActive(false);
        const id = setTimeout(() => {
            setActiveContent(tabs[activeTab].content); // пересоберётся с актуальным t
            setIsActive(true);
        }, 500);
        return () => clearTimeout(id);
    }, [activeTab, i18n.language, t]); // <-- добавлено
    return (
        <AnimationRevealPage>
            <Header
                heading={t('faq.header.heading')}
                paragraph={t('faq.header.paragraph')}
                imageSrc={Photo}
                roundedHeaderButton={false}
            />

            <Layout>
                <SidebarContainer>
                    {tabs.map((tab, index) => (
                        <TabButton
                            key={index}
                            active={index === activeTab}
                            onClick={() => setActiveTab(index)}
                        >
                            <IconContainer>
                                <tab.Icon active={index === activeTab}/>
                            </IconContainer>
                            {tab.name}
                        </TabButton>
                    ))}
                </SidebarContainer>
                <ContentContainer isActive={isActive}>
                    {activeContent}
                </ContentContainer>
            </Layout>
            <Footer/>
        </AnimationRevealPage>
    );
}
